import React, { Component } from 'react'
import InAppForbidden from '../InAppForbidden'
import requestChannelAccess from 'components/Channels/dataSync/requestAccess'
import { Button } from 'components/base'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { createSuccessToasterMessage } from 'data/ui/actions'

export class ChannelForbidden extends Component {
  constructor(props) {
    super(props)
    this.state = {
      requested: false,
    }
  }

  onRequestAccess = () => {
    const { requested } = this.state
    if (requested) {
      return
    }

    const {
      channelId,
      requestChannelAccess,
      createSuccessToasterMessage,
    } = this.props
    requestChannelAccess({ channelId })
    createSuccessToasterMessage({ title: 'The admins have been notified' })
    this.setState({ requested: true })
  }

  render() {
    return (
      <InAppForbidden
        isPersonal={this.props.isPersonal}
        extraButton={
          <Button.Primary
            className="margin-right-normal font-weight-bold"
            onClick={this.onRequestAccess}
            disabled={this.state.requested}
          >
            Request access
          </Button.Primary>
        }
      />
    )
  }
}

export default compose(
  connect(
    null,
    {
      createSuccessToasterMessage,
    }
  ),
  requestChannelAccess
)(ChannelForbidden)
